export const onEditDialogDone = project => ({
  widget: 'projects',
  type: 'onEditDialogDone',
  payload: { project },
})



// WEBPACK FOOTER //
// ./src/projects/actions/onEditDialogDone.js